import { Box, Button, Stack, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { mbolfsAllStoresPage } from "./data";

function MboLfsHome() {
	const navigate = useNavigate();

	return (
		<Box direction="row" width="100%" justifyContent="space-around" flexWrap="wrap" p={2} boxSizing={"border-box"}>
			<Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"} pt={2}>
				<Typography variant="h4" align={"left"}>
					MBO / LFS STORES SUMMARY
				</Typography>
				<Button autoFocus variant="contained" onClick={() => navigate(mbolfsAllStoresPage)}>
					VIEW ALL STORES
				</Button>
			</Stack>
		</Box>
	);
}

export default MboLfsHome;
